<template>
  <div class="uk-text-large">
    <p class="uk-margin-remove" v-if="name">{{name}}</p>
    <p class="uk-margin-remove">{{addressLine2(address)}}</p>
    <p class="uk-margin-remove-top">{{addressLine3(address)}}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { addressMixin } from '../../utils/address';

export default defineComponent({
  props: ['name', 'address'],
  mixins: [addressMixin],
});
</script>